<template>
  <ZMainPage type="card">
    <div class="z-box-bg brl mb-2">
      <LineWrapper class="list" list>
        <LineItem v-for="(item, index) in list" :key="index" :label="item.label" :value="item.value"></LineItem>
      </LineWrapper>
    </div>
    <div class="z-box-bg brl mb-2">
      <el-table :data="listData" style="width: 100%" size="small" v-loading="loading">
        <el-table-column prop="student_name" label="姓名"> </el-table-column>
        <el-table-column prop="student_no" label="学号"> </el-table-column>
        <el-table-column prop="org_teacher_name" label="辅导教师"> </el-table-column>
        <el-table-column prop="qingjia_time" label="周期内请假时间"> </el-table-column>
        <el-table-column prop="content_tag" label="录入方式"> </el-table-column>
        <el-table-column prop="AI_analysis_score" label="辅导得分"> </el-table-column>
        <el-table-column prop="student_goal_analysis" label="目标管理">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.student_goal_analysis" size="small" effect="dark" :type="scope.row.student_goal_analysis === '完成' ? 'success' : 'danger'">
              {{ scope.row.student_goal_analysis }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="student_emotions_analysis" label="情绪关注">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.student_emotions_analysis" size="small" effect="dark" :type="scope.row.student_emotions_analysis === '完成' ? 'success' : 'danger'">
              {{ scope.row.student_emotions_analysis }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <template v-if="scope.row.status === 1">
              <el-button @click="handleDetail(scope.row)" type="text" size="small">详情</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <template #footer>
      <el-button type="primary" @click="$router.back()">返回</el-button>
    </template>
  </ZMainPage>
</template>
<script>
import LineItem from '@/components/common/LineItem'
import LineWrapper from '@/components/common/LineWrapper'
export default {
	_config:{"route":{"path":"details","meta":{"title":"查看"}}},
  components: { LineItem, LineWrapper },
  data() {
    return {
      list: [],
      listData: [],
      loading: false
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      let id = this.$route.query.id
      this.loading = true
      this.$_axios2
        .get('/api/teacher/moral-educationController/pc-details?id=' + id)
        .then(res => {
          const {
            data: { data }
          } = res
          this.listData = data.student
          this.list = [
            { label: '校区', value: data.school_name },
            { label: '年级', value: data.grade_name },
            { label: '政班', value: data.class_name },
            { label: '教师姓名', value: data.teacher_name },
            { label: '完成率', value: data.complete_rate + '%' },
            { label: '考核周期', value: data.day_describe },
            { label: '当前班级人数', value: data.student_count },
            { label: '周期内请假人数', value: data.qingjia_num },
            { label: '平均得分', value: data.AI_analysis_score_average },
            { label: '录音使用率', value: data.AI_analysis_number_rate },
          ]
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleDetail(row) {
      this.$router.push('/moral/one-on-one-tutoring/moral-one-to-one-record/detail?id=' + row.id + '&type=1')
    }
  }
}
</script>
<style lang="scss" scoped></style>
